/** Canonical lab clock — capacity is always IST. */
export const IST_TIMEZONE = "Asia/Kolkata";

/**
 * Temporary: surgery portal is UK-only.
 * Client wall-clock / time-difference calculations always use Europe/London.
 */
export const SURGERY_CLIENT_REGION = "UK";
export const SURGERY_CLIENT_TIMEZONE = "Europe/London";

export const REGION_TIMEZONES: Record<string, string> = {
  "US-east": "America/New_York",
  "US-west": "America/Los_Angeles",
  UK: "Europe/London",
  EU: "Europe/Berlin",
  IN: "Asia/Kolkata",
  Other: "UTC",
};

export const isUkSurgeryRegion = (region?: string | null): boolean =>
  String(region || "")
    .trim()
    .toUpperCase() === SURGERY_CLIENT_REGION;

export const timezoneForRegion = (_region?: string | null): string =>
  SURGERY_CLIENT_TIMEZONE;

const pad2 = (n: number) => String(n).padStart(2, "0");

export const formatYmd = (y: number, m: number, d: number) =>
  `${y}-${pad2(m)}-${pad2(d)}`;

/** Wall-clock parts of an instant in Europe/London (UK). */
export const ukNowParts = (date: Date = new Date()) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: SURGERY_CLIENT_TIMEZONE,
    hourCycle: "h23",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).formatToParts(date);

  const values: Record<string, string> = {};
  for (const part of parts) {
    if (part.type !== "literal") values[part.type] = part.value;
  }

  return {
    year: Number(values.year),
    month: Number(values.month),
    day: Number(values.day),
    hour: Number(values.hour),
    minute: Number(values.minute),
  };
};

/** Calendar "today" in UK time (not the browser's local zone). */
export const ukTodayDate = () => {
  const p = ukNowParts();
  return new Date(p.year, p.month - 1, p.day, 0, 0, 0, 0);
};

export const formatHourLabel = (hour: number) => {
  const period = hour >= 12 ? "PM" : "AM";
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12}:00 ${period}`;
};
